import PropTypes from 'prop-types';

import { Container, Stack, Typography } from '@mui/material';
import { TipsCard } from '../../organisms';

const LayoutTemplatePicture = (props) => {
  const {
    action,
    actionBeforeContent = false,
    children = null,
    containerMaxWidth = 'sm',
    picture,
    pictureSize = '',
    subtitle,
    severity = '',
    tip,
    title
  } = props;

  return (
    <Container id="layout-template-picture" maxWidth={containerMaxWidth} sx={styleContainer}>
      {picture && <Stack sx={stylePictureWrapper(pictureSize)}>{picture}</Stack>}

      <Stack sx={styleTextWrapper}>
        {title && (
          <Typography component="h2" variant="h4" align="center" id="title">
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography component="h3" variant="body1" align="center" id="subtitle" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Stack>

      {action && actionBeforeContent && <Stack sx={styleActionsBeforeWrapper}>{action}</Stack>}

      {children && <Stack sx={styleContentContainer}>{[children]}</Stack>}

      {tip && <TipsCard tip={tip} severity={severity} sx={{ my: 2 }} />}

      {action && !actionBeforeContent && <Stack sx={styleActionsWrapper}>{action}</Stack>}
    </Container>
  );
};
LayoutTemplatePicture.propTypes = {
  action: PropTypes.object,
  actionBeforeContent: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  containerMaxWidth: PropTypes.string,
  picture: PropTypes.object,
  pictureSize: PropTypes.string,
  severity: PropTypes.string,
  subtitle: PropTypes.string,
  tip: PropTypes.string,
  title: PropTypes.string
};

const styleContainer = {
  display: 'flex',
  flexFlow: 'column nowrap',
  flexGrow: 1,
  px: { xs: 0.5, sr: 1.5, sm: 2 },
  pb: 3
};

const stylePictureWrapper = (pictureSize) => {
  let height = 'auto';
  let my = 'initial';
  switch (pictureSize) {
    case 'small':
      height = { xs: 64, sm: 96, xl: 128 };
      break;
    case 'large':
      height = { xs: 180, sr: 200, sm: 220, md: 240, lg: 320, xl: 340 };
      my = { xs: 0.5, sr: 0.75, sm: 1, md: 1.25, lg: 1.5, xl: 1.75 };
      break;
    default:
      height = { xs: 160, sr: 180, sm: 200, md: 220, lg: 240, xl: 320 };
      break;
  }
  return {
    alignItems: 'center',
    div: { height, my },
    svg: { height: '100%', width: 'auto' }
  };
};

const styleTextWrapper = {
  alignItems: 'center',
  py: { xs: 1, sr: 2 },
  gap: { xs: 0.25, sr: 1 }
};

const styleContentContainer = {
  alignItems: 'stretch'
};

const styleActionsBeforeWrapper = {
  alignItems: 'center',
  mb: 2
};

const styleActionsWrapper = {
  flexGrow: 1,
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: { xs: 'stretch', sm: 'flex-start' },
  justifyContent: { xs: 'flex-end', sm: 'center' },
  gap: 2,
  pt: 3
  // button: { flexGrow: { xs: 0, sm: 1 } } // unbalanced in the initialized page
};

LayoutTemplatePicture.propTypes = {
  action: PropTypes.object,
  actionBeforeContent: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  containerMaxWidth: PropTypes.string,
  picture: PropTypes.object,
  pictureSize: PropTypes.string,
  tip: PropTypes.string,
  title: PropTypes.string,
  severity: PropTypes.string,
  subtitle: PropTypes.string
};

export default LayoutTemplatePicture;
